import {Subscribable} from './subscribable';

export class BaseDomainModel extends Subscribable {
  public init() {}
}
